import React from 'react';
import { Checkbox, Button, Divider, Form } from 'semantic-ui-react';
import { change, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { find } from 'lodash';
import PhotoBoothModal from '../../../../../../../containers/PhotoBoothModal';
import { Tech3Input, Tech3Select,Tech3RCheckbox } from '../../../../../../../components/FormElements';
import { required } from '../../../../../../../lib/FormValidators';

const occurrenceEventFormName = 'occurrenceEvent';

const EventForm = props => {
  let isExport =props.initialValues.is_exportable;
  let isAnalysable= props.initialValues.is_analysable;
  console.log("isExport",isExport)
  return (
    <PhotoBoothModal {...props}>
      <Form onSubmit={props.handleSubmit}>
        {props.initialValues && props.initialValues.id ? (
          <h2>Edit Event</h2>
        ) : (
          <h2>Create new Event</h2>
        )}
        <Field
          label="Event Name"
          name="name"
          type="text"
          placeholder="Event Name..."
          component={Tech3Input}
          validate={[required]}
        />

        <h4>Codification</h4>
        <Field
          label="Default Start Codification"
          name="start_marker"
          type="text"
          placeholder="Start Description..."
          component={Tech3Input}
          validate={[required]}
        />
        <Field
          label="Default End Codification"
          name="end_marker"
          type="text"
          placeholder="End Description..."
          component={Tech3Input}
          validate={[required]}
        />

        <Divider section />
        <Field
          label="Analysable? (AOI)"
          component={Tech3RCheckbox}
          name="is_analysable"
        />
        <br/>
       <Field
          label="Exportable? (Includ in export file)?"
          name="is_exportable"
          component={Tech3RCheckbox}
          defaultChecked
        />

        <Divider section />

        <Form.Group widths="equal">
          <Field
            label="Software"
            name="software_id"
            options={props.software}
            placeholder="Choose Software..."
            component={Tech3Select}
            upward
            validate={[required]}
            onChange={(event, newValue, previousValue) => {
              props.dispatch(change(occurrenceEventFormName, 'version_id', ''));
            }}
          />
          <Field
            label="Version"
            name="version_id"
            options={props.versions}
            placeholder="Choose Version..."
            component={Tech3Select}
            upward
            validate={[required]}
          />
        </Form.Group>

        {props.initialValues && props.initialValues.id ? (
          <Button type="submit" disabled={props.submitting}>
            Save
          </Button>
        ) : (
          <Button type="submit" disabled={props.submitting}>
            Add
          </Button>
        )}
      </Form>
    </PhotoBoothModal>
  );
};

EventForm.propTypes = {
  ...PhotoBoothModal.propTypes
};

EventForm.defaultProps = { ...PhotoBoothModal.defaultProps };

function nothing(){
return 0;
}
function onExportableClick(){

}

const eventForm = reduxForm({
  form: occurrenceEventFormName,
  enableReinitialize: true
})(EventForm);

export default connect(state => ({
  software: state.projects.software.map((software, i) => {
    return {
      key: `software_${software.id}`,
      text: software.name,
      value: software.id
    };
  }),
  versions: (() => {
    const occurrenceEventFormSelector = formValueSelector(occurrenceEventFormName);
    const softwareVersions = find(state.projects.software, {
      id: parseInt(occurrenceEventFormSelector(state, 'software_id'), 10)
    });

    if (!softwareVersions) return null;
    return softwareVersions.equipment_software_versions.map((version, i) => {
      return {
        key: version.id,
        text: version.version_name,
        value: version.id
      };
    });
  })()
}))(eventForm);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/components/experimentalDesign/modals/EventForm.js